//@flow
import React, { Component } from 'react';
import { compose } from 'recompose';
import theme from './FpVisitMarkerPopupOuter.scss';
import Div from 'common/components/core/wrappers/Div';
import StopPropagation from 'common/components/core/StopPropagation/StopPropagation';
import classnames from 'classnames';
import { themr, type ThemeType } from 'react-css-themr';

import {
    type MarkerPositionType,
    MarkerPopupPosition,
    getPopupPosition
} from 'common/components/core/v2/markers/MarkerUtil';

type Props = {
    theme: ThemeType,
    onMouseEnter?: () => void,
    onMouseLeave?: () => void,
    children: React$Element<any>,
    targetNode: HTMLDivElement,
    parentElRefForMarker: {
        current: ?HTMLDivElement
    },
    isSelected: boolean
};

type State = {
    markerPopupPosition: MarkerPositionType,
    popupStyle: Object
};

class FpVisitMarkerPopupOuter extends Component<Props, State> {
    state = {
        markerPopupPosition: MarkerPopupPosition.TOP,
        popupStyle: {}
    };

    componentDidMount() {
        const { targetNode, parentElRefForMarker } = this.props;
        if (
            parentElRefForMarker.current &&
            targetNode &&
            this.markerPopupRef.current
        ) {
            this.setPopupPosition(
                targetNode,
                parentElRefForMarker.current,
                this.markerPopupRef.current
            );
        }
    }

    componentWillUnmount() {
        this.props.onMouseLeave?.();
    }

    markerPopupRef = React.createRef<HTMLDivElement>();

    setPopupPosition(
        marker: HTMLDivElement,
        parentContainer: HTMLDivElement,
        popup: HTMLDivElement
    ) {
        const popupPosition = getPopupPosition(marker, parentContainer, popup);

        this.setState({
            markerPopupPosition: popupPosition.position,
            popupStyle: popupPosition.style
        });
    }

    render() {
        const {
            theme,
            onMouseEnter,
            onMouseLeave,
            children,
            targetNode,
            isSelected
        } = this.props;

        if (!targetNode) {
            return null;
        }
        const { markerPopupPosition, popupStyle } = this.state;

        const eventTypes = isSelected ? ['onMouseMove', 'onMouseOver'] : [];
        return (
            <StopPropagation eventTypes={eventTypes}>
                <Div key={'markerPopup'}>
                    <div
                        ref={this.markerPopupRef}
                        className={classnames(
                            theme.mouseEventsPopupouter,
                            theme[`markerPopup${markerPopupPosition}`]
                        )}
                        style={popupStyle}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                    >
                        <div className={theme.popupInnerWrap}>{children}</div>
                    </div>
                </Div>
            </StopPropagation>
        );
    }
}

export default compose(themr('FpVisitMarkerPopupOuter', theme))(
    FpVisitMarkerPopupOuter
);
